import { BaseEntity } from "@bndes/bndes-ux4/bndes-angular-utils";
import { Estado } from "./estado.model";
import {OperacaoGarantida} from './operacao-garantida.model';

export class Leilao extends BaseEntity {}

export class DetalheLeilao extends BaseEntity {

  dataEnvio: Date;
  dataRealizacao: Date;
  dataRecebimentoValorArrematado: Date;
	estado: Estado;
	sistemaRepasse: string;
	contratoRepasse: number;
  idCobranca: number;
  idLeilao: number;
  idOperacao: number;
  idOperacaoAgente: string;
  motivoEstado: string;
  cnpjAgenteFinanceiro: string;
  valorDevidoAoFundo: number;
  valorHonradoFinal: number;
  valorRecuperadoLeilao: number;
  valorHonradoRecuperarAntes?: number;
	multa?: boolean;
  historicoEstados: HistoricoEstadoLeilao[];
  valorCreditoOperacao?: number;
  ideAgente?: number;

}

export class HistoricoEstadoLeilao {
  id: number;
  dataUltimaAtualizacao: Date;
  estado: Estado;
  nomeUsuarioResponsavel: string;
}

export const leilaoLoteExemplo = `
{
  "cnpjAgenteFinanceiro": "00000000000191",
  "lotes": [
    {
      "valorArrematadoLote": 250000.01,
      "dataRealizacaoLeilao": "2025-03-10",
      "dataRecebimentoValorArrematado": "2025-03-25",
      "operacoes": [
        {
          "idOperacaoAgenteCreditoLivre": "TECTE-CL111"
        },
        {
          "idOperacaoAgenteCreditoLivre": "TECTE-CL222"
        },
        {
          "idOperacaoAgenteCreditoLivre": "TECTE-CL333"
        },
        {
          "sistemaRepasse": "15",
          "contratoRepasse": "1111111111"
        },
        {
          "sistemaRepasse": "15",
          "contratoRepasse": "2222222222"
        },
        {
          "sistemaRepasse": "89",
          "contratoRepasse": "33333333333"
        }
      ]
    },
    {
      "valorArrematadoLote": 200000.0,
      "dataRealizacaoLeilao": "2025-03-25",
      "dataRecebimentoValorArrematado": "2025-04-02",
      "operacoes": [
        {
          "idOperacaoAgenteCreditoLivre": "TECTE-CL23232"
        },
        {
          "sistemaRepasse": "89",
          "contratoRepasse": "123456789"
        }
      ]
    }
  ]
}

`;
